'use client'
export default function Error() {
  return (
    <div>
      <h2>Error Page</h2>
    </div>
  )
}